'use client'

import { cn } from '@/lib/utils'
import type { Platform } from '@/types/market'
import Image from 'next/image'

type PlatformBadgeProps = {
	platform: Platform
	className?: string
}

const PLATFORM_LOGOS: Record<Platform, string> = {
	kalshi: '/logos/kalshi.jpeg',
	polymarket: '/logos/polymarket.jpeg',
	opinionlabs: '/logos/opinionlabs.png',
	predictfun: '/logos/predict.png',
	limitless: '/logos/limitless.png',
}

export function PlatformBadge({ platform, className }: PlatformBadgeProps) {
	return (
		<div className={cn('relative h-5 w-5 flex-shrink-0 overflow-hidden rounded-full', className)}>
			<Image
				src={PLATFORM_LOGOS[platform]}
				alt={platform}
				fill
				className="object-cover"
				sizes="20px"
			/>
		</div>
	)
}
